"use client";

import { useEffect, useState } from "react";

const TRANSLATIONS = {
  en: {
    title: "Something went wrong",
    description: "We're sorry, but something unexpected happened. Please try again later.",
    contactSupport: "If the problem persists, feel free to contact support.",
  },
  ar: {
    title: "حدث خطأ ما",
    description: "نأسف، لكن حدث شيء غير متوقع. يرجى المحاولة مرة أخرى لاحقاً.",
    contactSupport: "إذا استمرت المشكلة، لا تتردد في التواصل مع الدعم الفني.",
  },
} as const;

type Lang = keyof typeof TRANSLATIONS;

export default function ErrorPage() {
  const [lang, setLang] = useState<Lang>("en");

  useEffect(() => {
    try {
      const stored = localStorage.getItem("language") as Lang | null;
      if (stored && stored in TRANSLATIONS) {
        setLang(stored);
      }
    } catch {
    }
  }, []);

  const tr = TRANSLATIONS[lang];

  return (
    <div
      className="flex min-h-[90vh] flex-col items-center justify-center mx-auto max-w-container px-4 md:px-banner-padding mt-24 mb-20 text-center relative overflow-hidden"
      dir={lang === "ar" ? "rtl" : "ltr"}
    >
      <div className="relative z-10 mx-auto">
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 tracking-tight max-w-2xl">
          {tr.title}
        </h1>

        <p className="text-gray-700 text-xl mb-12 max-w-xl mx-auto leading-relaxed">
          {tr.description}
        </p>

        <p className="text-gray-500 text-sm mt-8">{tr.contactSupport}</p>
      </div>
    </div>
  );
}